import React, { ReactNode } from "react";
import styles from "./main-container.module.scss";

interface MainContainerPropTypes {
  children: ReactNode;
}

const cssClassName = "main-container";

export const MainContainer = ({ children }: MainContainerPropTypes) => {
  return <div className={styles[cssClassName]}>{children}</div>;
};
